import { render } from "./DCatalogueItemCatalogue.vue?vue&type=template&id=c6296862&ts=true"
import script from "./DCatalogueItemCatalogue.vue?vue&type=script&lang=ts"
export * from "./DCatalogueItemCatalogue.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__